module.exports = {
      id: "SCF-logo-30-Years-usage",
      viewBox: "0 0 354.19 400.88",
      url: __webpack_public_path__ + "images/sprites.min-761fd8cda42a160ac5ce8fc99730232c.svg#SCF-logo-30-Years-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./client/src/site__scf001/components/site/sprites/SCF-logo-30-Years.svg
// module id = /home/vsts/work/1/s/src/SCF/node_modules/svg-sprite-loader/lib/loader.js??ref--12-0!/home/vsts/work/1/s/src/SCF/client/src/site__scf001/components/site/sprites/SCF-logo-30-Years.svg
// module chunks = site__scf001